const daysOrder = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7,
};
const getDaysInOrder = (daysList, sortKey) => daysList.sort((a, b) => {
    const day1 = a[sortKey].toLowerCase();
    const day2 = b[sortKey].toLowerCase();
    return daysOrder[day1] - daysOrder[day2];
});

export { getDaysInOrder };
